export { default } from "./SpinnerWithCard";



// WEBPACK FOOTER //
// ./src/components/common/spinnerWithCard/index.js